import React from 'react';

import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';

import { usePreferredOptionContext, usePricingOptionNamesContext } from './PricingToolSessionContext';
import { PRICING_OPTION_LABELS, optionLabel } from './constants';
import type { PreferredOption } from './types';

export default function PricingToolToolbarActions() {
  const { preferredOption, setPreferredOption } = usePreferredOptionContext();
  const { optionNames } = usePricingOptionNamesContext();

  const handlePreferredOptionChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setPreferredOption(value === '' ? null : (Number(value) as PreferredOption));
  };

  return (
    <Stack alignItems="center" direction="row" justifyContent="flex-end" spacing={1}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="preferred-option-label">Preferred option</InputLabel>
        <Select
          label="Preferred option"
          labelId="preferred-option-label"
          onChange={handlePreferredOptionChange}
          value={preferredOption !== null ? String(preferredOption) : ''}
        >
          <MenuItem value="">None</MenuItem>
          {PRICING_OPTION_LABELS.map((_, index) => (
            <MenuItem key={index} value={String(index + 1)}>
              {optionLabel(optionNames, index)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button disabled size="small" variant="outlined">
        Load Session
      </Button>
      <Button disabled size="small" variant="outlined">
        Save Session
      </Button>
      <Button disabled size="small" variant="contained">
        Export
      </Button>
    </Stack>
  );
}
